import React from 'react';
import CountryIcon from '~/UI/CountryIcon';

export interface ProductModuleTypeProps {
	countryCode: string;
	moduleType: string;
}

export function ProductModuleType({ countryCode, moduleType }: ProductModuleTypeProps) {
	return (
		<div className='inline-flex flex-row flex-nowrap items-start justify-center'>
			<CountryIcon code={countryCode} />
			<span className='ml-2 inline-block text-[14px] font-semibold text-gray-500 leading-5 not-italic tracking-wider'>
				{moduleType}
			</span>
		</div>
	);
}
